function setActivePriceTab(element) {
  var items = document.querySelectorAll(".plans__list .plan-data");
  items.forEach(function (item) {
    item.classList.remove("active");
  });
  element.classList.add("active");
}

//document.addEventListener("DOMContentLoaded", function () {
  // var items = document.querySelectorAll(".plans__list .plan-data");
  // items.forEach(function (item) {
  //   item.addEventListener("click", function () {
  //     var targetDataAttr = this.getAttribute("data-attr");
  //     var targetitems = document.querySelectorAll(
  //       ".tabs_details-content-inner .details-tab"
  //     );
  //     targetitems.forEach(function (targetitem) {
  //       targetitem.classList.remove("active");
  //     });
  //     var targetitemsactive = document.querySelector(
  //       '.tabs_details-content-inner [target-data-attr="' +
  //         targetDataAttr +
  //         '"]'
  //     );
  //     targetitemsactive.classList.add("active");
  //     setActivePriceTab(this);
  //   });
  // });
//});
document.addEventListener("DOMContentLoaded", function () {
  var checkbox = document.querySelector(".js-toggle-prices");
  if (!checkbox) return;

  function updatePlans() {
    document.querySelectorAll(".plans__list .plan-data").forEach(function (priceItem) {
      var offerEl = priceItem.querySelector(".js-price-change");
      var oldEl   = priceItem.querySelector(".js-old-price");
      if (oldEl && oldEl.style.display !== "none") { /* keep */ }
      var btnEl   = priceItem.querySelector(".btn");

      if (!offerEl) return;

      var mode = checkbox.checked ? "monthly" : "yearly";

      // Update OFFER price
      var offerVal = offerEl.getAttribute("data-" + mode) || "";
      offerEl.innerHTML = offerVal;

      // Update OLD price
      if (oldEl) {
        var oldVal = oldEl.getAttribute("data-" + mode) || "";
        oldEl.innerHTML = oldVal;

        // Hide old price if empty OR same as offer
        var showOld = oldVal.trim() !== "" && oldVal.trim() !== offerVal.trim();
        oldEl.style.display = showOld ? "" : "none";
      }

      // Update button URL (optional)
      if (btnEl) {
        var url = btnEl.getAttribute("data-" + mode);
        if (url) btnEl.href = url;
      }
    });
  }

  // ✅ run once on load
  updatePlans();

  // run on toggle
  checkbox.addEventListener("change", updatePlans);
});
